import { UserResult } from 'aos-services/src/services/users/types/UserResult'
import { userSearchService } from 'aos-services/src/services/users/userSearchService'
import { MultiSelectAutocomplete } from 'aos-ui-universal'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface TaskAssigneesAutocompleteProps {
    value: UserResult[]
    onChange(v: UserResult[]): void
}

export const TaskAssigneesAutocomplete: FC<TaskAssigneesAutocompleteProps> = ({
    value,
    onChange,
}) => {
    const { t: translate } = useTranslation()

    return (
        <MultiSelectAutocomplete<UserResult>
            value={value}
            onSearch={userSearchService.searchForUsers}
            labelRenderer={v => v.name}
            keyExtractor={v => String(v.id)}
            placeholder={translate('autocomplete.select-users.placeholder', { ns: 'tasks' })}
            emptyText={translate('dropdown.empty', { ns: 'common' })}
            loadingText={translate('dropdown.loading', { ns: 'common' })}
            errorText={translate('error.something-went-wrong', { ns: 'common' })}
            onChange={onChange}
        />
    )
}
